import { render, staticRenderFns } from "./BirdSaleAdd.vue?vue&type=template&id=2e86ab15&scoped=true&"
import script from "./BirdSaleAdd.vue?vue&type=script&lang=js&"
export * from "./BirdSaleAdd.vue?vue&type=script&lang=js&"
import style0 from "./BirdSaleAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e86ab15",
  null
  
)

export default component.exports